<template>
  <main>
    <Trail />
    <Container class="container--main">
      <div v-if="edificacion">
        <Title tag="h2">Edificación Instrumentada: </Title>
        <div class="edi__box">
          <div class="edi__title">
            <p>
              <span class="sub__primary">Nombre del edificio:</span>
              {{ edificacion.nombre }} ({{ tipo.toUpperCase() }})
            </p>
          </div>
          <div class="edi__prop">
            <!-- <div>
              <p>
                <span class="sub__primary">Código de registro:</span>
                {{ edificacion.codigo }}
              </p>
            </div> -->
            <div>
              <p>
                <span class="sub__primary">Ubicación:</span>
                {{ getFormatCoordinate(edificacion.posicion.coordinates[1]) }},
                {{ getFormatCoordinate(edificacion.posicion.coordinates[0]) }}
              </p>
            </div>
          </div>

          <hr />
          <div class="edi__table">
            <Title tag="h3">Eventos</Title>
            <TableUi>
              <template v-slot:header>
                <tr>
                  <th :key="i" v-for="(cabeza, i) of cabecera">
                    {{ cabeza.label }}
                  </th>
                </tr>
              </template>
              <template v-slot:body>
                <tr v-for="event in eventosFiltrados" :key="event.fechaHora">
                  <td>
                    {{ localDate(event.fechaHora) }}
                  </td>
                  <td>
                    {{
                      getFormatCoordinate(
                        event.posicion.coordinates[0].toString().slice(0, 6)
                      )
                    }},
                    {{
                      getFormatCoordinate(
                        event.posicion.coordinates[1].toString().slice(0, 6)
                      )
                    }}
                  </td>
                  <td>
                    {{ event.magnitud }}
                  </td>
                  <td>
                    {{ event.profundidad }}
                  </td>
                  <td class="actions__">
                    <Button
                      type="button"
                      theme="primary"
                      target="_blank"
                      @click="
                        getPathEspectro(event.fechaHora, edificacion.codigo)
                      "
                    >
                      <Icon svg="watch" />
                    </Button>
                    <span>
                      <Button
                        type="button"
                        theme="primary"
                        target="_blank"
                        @click="
                          getDownload(event.fechaHora, edificacion.codigo)
                        "
                      >
                        <Icon svg="download" />
                      </Button>
                    </span>
                  </td>
                </tr>
              </template>
            </TableUi>
          </div>
        </div>
      </div>
      <div v-else>
        Loading ...
      </div>
    </Container>

    <!-- Modal espectro -->
    <Modal :showModal="showModal" centered v-on:close="modalClose">
      <template v-slot:header>
        <h3>Espectro de respuesta</h3>
      </template>
      <template v-slot:body>
        <img
          style="height: 60vh;"
          :src="pathEspectro"
          alt="Espectro de respuesta"
        />
      </template>
    </Modal>
    <!-- Modal espectro E N D -->
  </main>
</template>

<script>
import Trail from "@/components/common/Trail.vue";
import Container from "@/components/ui/objects/Container.vue";
import Title from "@/components/ui/atoms/Title.vue";
import Button from "@/components/ui/atoms/Button";
import TableUi from "@/components/ui/objects/TableUi.vue";
import Icon from "@/components/ui/atoms/Icon";
import Modal from "@/components/common/Modal.vue";
import axios from "axios";

export default {
  components: {
    Trail,
    Container,
    Title,
    Button,
    TableUi,
    Icon,
    Modal,
  },

  props: ["code"],

  data() {
    return {
      edificacion: null,
      tmpEdificacion: null,
      eventosFiltrados: [],
      tipo: null,
      cabecera: [
        {
          label: "Fecha local y hora local",
          value: "fecha_hora",
        },
        {
          label: "Ubicación",
          value: "ubicacion",
        },
        {
          label: "Magnitud",
          value: "magnitud",
        },
        {
          label: "Profundidad",
          value: "profundidad",
        },
        {
          label: "Acciones",
          value: "acciones",
        },
      ],
      yyyy: null,
      mm: null,
      dd: null,
      hh: null,
      min: null,
      ss: null,
      src: null,
      showModal: false,
      pathEspectro: null,
      close: false,
    };
  },

  async created() {
    this.tipo = this.$route.params.type;

    try {
      let token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const response = await axios.get(
        `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/registros/${this.code}`
      );
      this.tmpEdificacion = response.data;
      let event = response.data[0];
      this.edificacion = {
        nombre: event.nombre,
        posicion: event.posicion,
        codigo: this.code,
      };

      if (this.tmpEdificacion.length > 0) {
        this.eventosFiltrados = this.tmpEdificacion
          .map((item) => item[`eventos_${this.tipo}`] || [])
          .flat()
          .sort((a, b) => new Date(b.fechaHora) - new Date(a.fechaHora)); // Ordena por fecha descendente
      }
    } catch (error) {
      console.log(error);
    }
  },

  methods: {
    localDate(fechaUTC) {
      const date = new Date(fechaUTC);
      const options = {
        hour12: false,
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        timeZone: "America/Lima",
        year: "numeric",
        month: "numeric",
        day: "numeric",
      };
      return date.toLocaleString("es-PE", options);
    },

    async getDownload(date, code) {
      let yyyy = date.slice(0, 4);
      let mm = date.slice(5, 7);
      let dd = date.slice(8, 10);
      let hh = date.slice(11, 13);
      let min = date.slice(14, 16);
      let ss = date.slice(17, 19);
      let dateCode = yyyy + mm + dd + "_" + hh + min + ss + "_" + code;
      let token = localStorage.getItem("token");
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      const response = await axios({
        method: "get",
        url:
          `${process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC}/e030/file/` +
          `${dateCode}` +
          `.txt/${token}`,
        reponseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${dateCode}`);
      document.body.appendChild(link);
      link.click();
    },

    getFormatCoordinate(coordinate) {
      return parseFloat(coordinate).toFixed(3);
    },

    getPathEspectro(date, code) {
      let yyyy = date.slice(0, 4);
      let mm = date.slice(5, 7);
      let dd = date.slice(8, 10);
      let hh = date.slice(11, 13);
      let min = date.slice(14, 16);
      let ss = date.slice(17, 19);
      const dateCode = yyyy + mm + dd + "_" + hh + min + ss + "_" + code;
      console.log(dateCode);
      const token = localStorage.getItem("token");
      const baseUrl = process.env.VUE_APP_API_ACELEROMETRICA_PUBLIC;
      this.pathEspectro = `${baseUrl}/e030/file/${dateCode}.webp/${token}`;
      this.showModal = true;
    },

    modalClose() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/styles/settings/_variables.scss";
.edi__box {
  border: 2px solid variables.$primary-color;
  border-radius: 10px;
}

.edi__title {
  background: variables.$primary-color;
  color: white;
  padding: 1.2rem 0.3rem;
}

.edi__title p {
  margin-bottom: 0px !important;
}

.edi__prop {
  display: flex;
  gap: 10rem;
  padding: 1.3rem 1rem;
}

.edi__prop div p {
  margin-bottom: 0px !important;
}

.edi__table {
  padding: 1.2rem;
}

.sub__primary {
  font-weight: bold;
  padding-left: 1.2rem;
}

.actions__ {
  display: flex;
  justify-content: space-around;
}
</style>
